import { IS_BUILD_PAGE, IS_MODELS_PAGE, IS_TIER1_PAGE } from '../constants/environment';

/* eslint-disable no-nested-ternary */
const formType = {
  general: 'general',
  testDrive: 'test_drive',
  pricing: 'pricing',
  promotion: 'specials',
  service: 'service',
  parts: 'parts',
  requestCall: 'requestCall',
  other: 'other',
};

export const formTypeFormatter = (
  isVehicleInfoAvailable: boolean,
  source: string,
  topicOfInterest: keyof typeof formType | '',
) => {
  const contact = IS_TIER1_PAGE ? 'Contact' : 'contact';

  const isVinSpecific = isVehicleInfoAvailable ? 'dealervin' : 'dealer';

  const genericTopic = IS_TIER1_PAGE ? 'generic' : 'general';

  if (topicOfInterest && !IS_MODELS_PAGE && !IS_BUILD_PAGE) {
    const formTypeOfTopic =
      topicOfInterest === 'general' ? genericTopic : formType[topicOfInterest];
    return `${contact}_dealer-${formTypeOfTopic}`;
  }
  return `${contact}_${isVinSpecific}-${source}`;
};

export default formTypeFormatter;
